import { inject, Injectable } from '@angular/core';

import { SidenavStore } from '#core/components/sidenav/store/sidenav.store';

@Injectable()
export class GroupsResolver {
    private readonly _sidenavStore = inject(SidenavStore);

    resolve(): void {
        this._sidenavStore.setSelectedRestaurant(null);
    }
}
